import { Button } from "@components/ui/button"
import { ExternalLink, Loader2 } from "lucide-react"
import { toast } from "sonner"
import { useCorrespondenceResolver } from "./utils/useCorrespondenceResolver"

interface TViewLetterButtonProps {
  account_id: string
  account_correspondence_id: number
  isWelcome: boolean
}

export const ViewLetterButton = ({
  account_id,
  account_correspondence_id,
  isWelcome,
}: TViewLetterButtonProps) => {
  const { getLetterUrl, isCorrespondenceResolverFetching } =
    useCorrespondenceResolver({
      account_id,
      account_correspondence_id,
      isWelcome,
    })

  const handleClick = async () => {
    const url = await getLetterUrl()
    if (!url) {
      toast.error("Error fetching letter!")
      return
    }

    window.open(url, "_blank", "noopener,noreferrer")
  }

  return (
    <Button
      size="icon"
      variant="ghost"
      onClick={handleClick}
      disabled={
        (!account_correspondence_id && !isWelcome) ||
        isCorrespondenceResolverFetching
      }
    >
      {isCorrespondenceResolverFetching ? (
        <Loader2 className="tw:animate-spin" />
      ) : (
        <ExternalLink />
      )}
    </Button>
  )
}
